import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { kebabCase } from 'lodash';
import type { RootState } from '../core/store';

export interface GlobalParametersState {
  values: { [key: string]: string | undefined };
}

const initialState: GlobalParametersState = {
  values: {},
};

export const globalParametersSlice = createSlice({
  name: 'globalParameters',
  initialState,
  reducers: {
    setGlobalParameter: {
      reducer(state: GlobalParametersState, action: PayloadAction<string | undefined, string, { key: string }>) {
        const key = kebabCase(action.meta.key);
        state.values[key] = action.payload;
      },
      prepare(key: string, payload?: string) {
        return { payload, meta: { key } };
      },
    },
  },
});

export default globalParametersSlice.reducer;

export const { setGlobalParameter } = globalParametersSlice.actions;

export const globalParameterSelector = (key: string) => (state: RootState) =>
  state.globalParameters.values[key] ?? undefined;
